import { OrderBus } from './OrderBus'
import { OrderDetailsBus } from "./OrderDetailsBus";
import { AttachmentBus } from "./AttachmentBus";
import { DQOIErrorBus } from "./DQOIError";
import { CommonFunctions } from '../static/common-functions';
import { OrderNotesBus } from './OrderNotesBus';

export class OrderSaveParam extends OrderBus {
    constructor(data: OrderBus) {
        super(data);
    }
    public attachments: AttachmentBus[];
    public errors: DQOIErrorBus[];
    public orderNotes: OrderNotesBus[];
    public get hasLines(): boolean {
        return CommonFunctions.hasArrayElementValue(this.orderDetails);
    }
    public get hasAttachments(): boolean {
        return CommonFunctions.hasArrayElementValue(this.attachments);
    }
    public get hasErrors(): boolean {
        return CommonFunctions.hasArrayElementValue(this.errors);
    }
    public get hasNotes(): boolean {
        return CommonFunctions.hasArrayElementValue(this.notes);
    }
}

